import {
  LightningIcon,
  SlidersHorizontalIcon,
  UserIcon,
} from "@phosphor-icons/react";
import { useTranslate } from "@refinedev/core";
import { Typography } from "antd";
import { useAntTheme } from "hooks/useAntTheme/";

export const OptionButtonHeader = ({
  variant,
}: {
  variant: "flash" | "advanced" | "heyGeniusDoc";
}) => {
  const { theme } = useAntTheme();
  const t = useTranslate();
  const headers = {
    flash: {
      icon: (
        <LightningIcon size={48} weight="duotone" color={theme.colorWarning} />
      ),
      title: t("projects.components.ProjectCreationPage.flashProject"),
      subtitle: t(
        "projects.components.ProjectCreationPage.flashProjectSubtitle"
      ),
    },
    advanced: {
      icon: (
        <SlidersHorizontalIcon
          size={48}
          weight="duotone"
          color={theme.colorPrimary}
        />
      ),
      title: t("projects.components.ProjectCreationPage.advancedProject"),
      subtitle: t(
        "projects.components.ProjectCreationPage.advancedProjectDescription"
      ),
    },
    heyGeniusDoc: {
      icon: <UserIcon size={48} weight="duotone" color={theme.colorPrimary} />,
      title: t("projects.components.ProjectCreationPage.heyGeniusDocProject"),
      subtitle: t(
        "projects.components.ProjectCreationPage.heyGeniusDocProjectDescription"
      ),
    },
  };
  return (
    <>
      {headers[variant].icon}
      <Typography.Title level={4} style={{ margin: "16px 0 8px" }}>
        {headers[variant].title}
      </Typography.Title>
      <Typography.Text type="secondary">
        {headers[variant].subtitle}
      </Typography.Text>
    </>
  );
};
